import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DesktopErrorHandler } from '../services/errorHandler.service';
import { FamilyEntity, FamilyStateModel, ClearSubscriptions, CommonService,   GetFamilyById, PatientEntity, GetProviderSettings, GetServiceLevels, Time, NetworkMember, ServiceLevel,Provider, Config, Address, Phone, ProviderSetting, FamilyPatient, Appointment , GetAppointments, SchedulingStateModel, GetChecklistTemplates, CompassStateModel, ChecklistTemplate, TeamMember, ScoredSubscription, GetServiceLevelsForTeamIds, GuidanceSubscriptionModel, GetGuidanceSubs, DateUtil } from 'huddyapi';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { EditFamilyDialog } from '../components/edit-family-dialog/edit-family-dialog-component';
import { CommunityConfigService } from '../services/community-config.service';
import { Util } from "../components/util";


@Component({
  selector: 'family-detail',
  templateUrl: './family-detail.component.html',
  styleUrls: ['./family-detail.component.scss']
})
export class FamilyDetailComponent implements OnInit{

  @Select(state => state.familyState) familyState$: Observable<FamilyStateModel>;

  familySubscription : Subscription;
  appointmentsSubscription : Subscription;
  family : FamilyEntity;
  tabIndex : number;
  compassStateSubscription: Subscription;
  serviceLevels : ServiceLevel[];
  appointments : Appointment[];
  settings : ProviderSetting[];
  currentMembers : TeamMember[];
  serviceLevelsFired : boolean;
 

  checklistTemplates : ChecklistTemplate[];
  providers: Provider[];
  user : string;
  @Select(state => state.compassState) compassState$: Observable<CompassStateModel>;

  @Select(state => state.guidanceSubscriptions) guidanceSubscriptionState$: Observable<GuidanceSubscriptionModel>;
  @Select(state => state.schedulingState) schedulingState$: Observable<SchedulingStateModel>;
  private routeSub:any;
  guidanceSubSubscription : Subscription;
  scoredCompasses : ScoredSubscription[];
  dispatchedScoredCompasses : boolean = false;
  familyId: number;

  constructor(
    private store: Store,
    private config: Config,
    private commonService: CommonService,
    private route: ActivatedRoute,
    public router: Router,
    public dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    
    // this.matIconRegistry.addSvgIcon('red',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/red_alert.svg'));
    // this.matIconRegistry.addSvgIcon('yellow',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/yellow_alert.svg'));
    // this.matIconRegistry.addSvgIcon('green',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/green_alert.svg'));
   
  }

  public ngOnDestroy() {
    this.routeSub.unsubscribe();


  }
  
  

  ngOnInit(): void {
    
    this.familyId = parseInt(this.route.snapshot.paramMap.get('familyId'));
    //this.scoredCompasses = [];

   const defaultTabIndex =  0;
   this.setTab(defaultTabIndex);
   this.routeSub = this.router.events.subscribe((event) => {
    console.log(event);
    if (event instanceof NavigationStart) {
      this.clearState();
    }
  });
   this.user = CommonService.currentUserToView;
   this.familySubscription = this.familyState$.subscribe((familyState: FamilyStateModel) => {
      if (familyState && familyState.currentFamily && familyState.currentFamily.id === this.familyId) {
        this.family = familyState.currentFamily;
        console.log('Current family', this.family);
        if (this.family.patients && !this.serviceLevelsFired) {
          this.serviceLevelsFired = true;
          const providerId = this.family.patients[0].patient.providerId;
          this.store.dispatch( new GetServiceLevels(providerId));
          this.store.dispatch( new GetProviderSettings(providerId));
          this.store.dispatch(new GetChecklistTemplates(providerId));
  
        }
      }
    });
    this.appointmentsSubscription = this.schedulingState$.subscribe((schedulingState : SchedulingStateModel) => {

        if ( schedulingState.familyAppointments)  {
          this.appointments = [].concat(schedulingState.familyAppointments);
        }
        if (schedulingState.teamMembers) {
          this.currentMembers = [].concat( schedulingState.teamMembers);
          if (this.currentMembers.length > 0) {
            const teamId : number = this.currentMembers[0].groupId;
          }
        } 
      
    });
    this.store.dispatch( new GetFamilyById(this.familyId));
    this.store.dispatch(new GetAppointments(this.familyId));
    this.compassStateSubscription = this.compassState$.subscribe((compassState: CompassStateModel) => {
      console.log('compassState', compassState);
      if (compassState.providers && compassState.providers.length > 0) {
        this.providers = compassState.providers;
      }
      if (compassState.providerSettings && compassState.providerSettings.length > 0) {
        this.settings = compassState.providerSettings;
      }
      if (compassState.serviceLevels && compassState.serviceLevels.length > 0) {
        console.log('setting servicelevels ', compassState.serviceLevels);
        this.serviceLevels = compassState.serviceLevels;
      }
    });
    this.compassStateSubscription = this.compassState$.subscribe((state: CompassStateModel) => {
      //console.log('got checklist templates', state.checklistTemplates);
      if (state.checklistTemplates || state.checklistTemplates?.length > 0)
        this.checklistTemplates = [].concat(state.checklistTemplates);
    });
    if (!this.dispatchedScoredCompasses) {
      this.getGuidanceSubs();
    }

    this.guidanceSubSubscription = this.guidanceSubscriptionState$.subscribe((guidanceSubModel: GuidanceSubscriptionModel) => {
      if (this.family) {
        if (guidanceSubModel && guidanceSubModel.familySubscriptions) {
          this.scoredCompasses = guidanceSubModel.familySubscriptions.sort(this.compareScoredSubscriptions);
        }
        console.log('Scored compasses', this.scoredCompasses);
      }
    }); 
  
  }

  compareScoredSubscriptions(s1: ScoredSubscription, s2: ScoredSubscription) {
    
    if ( s1.lastAssessmentDay < s2.lastAssessmentDay ){
      return 1;
    }
    if ( s1.lastAssessmentDay > s2.lastAssessmentDay ){
      return -1;
    }
    return 0;
  }

  setTab(tabIndex: number) {
    this.tabIndex = tabIndex;
  }

  getGuidanceSubs() {
    let action = new GetGuidanceSubs(true, false, undefined, this.familyId);
    this.dispatchedScoredCompasses = true;
    console.log('Firing get guidance subs', action);
    this.store.dispatch(action);
  }


  onEdit() {
    
    this.family.tags =   this.resolvePrimary().tags;
    let familyDialog = this.dialog.open(EditFamilyDialog, {
      width: '600px',
      height: '650px',
      data: {
        family: this.family,
        fromFamilyPatient: false
      }
    });
    familyDialog.afterClosed().subscribe(family =>  this.store.dispatch( new GetFamilyById(this.family.id)));
  }

  getServiceLevel() {
   // console.log('getServiceLevels', this.serviceLevels, this.family.serviceLevelId);
    if (this.serviceLevels && this.family.serviceLevelId) {
      let serviceLevel : ServiceLevel = this.serviceLevels.find(sl => sl.id === this.family.serviceLevelId);
      if (serviceLevel) {
        return serviceLevel.name;
      }
    }
    return 'not assigned';
  }

  getTeamsAsString() : string {
    let ret : string = 'not assigned';
    if (this.family.practitionerGroups) {
      ret = this.family.practitionerGroups.map(pg => pg.name).join(', ');
    }
    return ret;
  }

 getFriendlyName(patient : PatientEntity) {
  let ret =  patient.firstName ? patient.firstName + ' ' : '';
  if (patient.lastName)
    ret = ret + patient.lastName;
  return ret;
 }

  getProviderName() : string {
    if (this.providers && this.providers.length > 1 && this.family) {
      let names : string[] = this.providers
      .filter(p => this.family.patients.filter(pt => pt.patient.providerId === p.id).length > 0)
      .map(p => p.name);
      if (names.length > 0) {
        return '(' + names[0] + ') ';
      }
    }
    return '';
  }

  resolvePrimary() : PatientEntity {
   
    let patientArr : FamilyPatient[] = this.family.patients
    .filter(fr => fr.relationship === 'PRIMARY');
    
    if (patientArr.length > 0) {
      return patientArr[0].patient;
    }
    return undefined;  
  }

  getColorFromName(name : string, fromPatient? :boolean) : string {
    let ret : string = '#DAC7FD';
    if (fromPatient) {
      let patient : PatientEntity = this.resolvePrimary();
      name = 'p';
      if (patient) {
        if (patient && patient.lastName) {
          name = patient.lastName;
        }
      }
    }
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

  getFamilyInitials() : string {
    let ret : string = 'p';
    let patient : PatientEntity = this.resolvePrimary();

    if (patient) {
      if (patient.lastName && patient.lastName.indexOf('null') === -1) {
        ret = patient.lastName.substring(0, 1);
        ret = ret.toLowerCase();
      } else {
        ret = patient.username.substring(0,1).toLowerCase();
      }
    }
    return ret;
  }



  epochDayToDate(epochDay: number) : string {
    if (epochDay <= 0) {
      return '';
    }
    return   Time.fromEpochDay(epochDay).getDateDisplay() ;
  }


  getLetters(name: string): string {
    name = name.trim();
    return name.substring(0, 1);
  }

  gotoCompasses() {
    this.tabIndex = 0;
  }

  showAssessment(subscriptionId : number, lastAssessmentDay : number) {
    if (CommonService.jwt && CommonService.jwt.length > 7 && lastAssessmentDay > 0) {
      let token : string = CommonService.jwt.substring(7);
      let url : string = this.config.getEndpoint() + '/report-for-subscription?subscriptionId=' + subscriptionId + '&access_token=' + token;
      window.open(url);      
    }
  }

  getPatientName(patient : PatientEntity) : string {
    let ret : string = 'Unknown';
    if (patient) {
      ret = '';
       if (patient.firstName) {
          ret = patient.firstName + ' ';
       }
       ret += patient.lastName;
      if (!ret || ret.indexOf("null ") > -1) {
        ret = patient.username;
      }
    }
    return ret;
  }


  getFamilyName() : string {
    let ret : string = 'Unknown';
    let patient : PatientEntity = this.resolvePrimary();
   
    if (patient) {
       ret = patient.lastName;
      if (!ret || ret.indexOf("null ") > -1) {
        ret = patient.username;
      }
    }
    return ret;
  }

  getAddress() : string {
    let ret : string = 'Unknown';
    let patient : PatientEntity = this.resolvePrimary();
   
    if (patient && patient.addresses && patient.addresses.length > 0) {
       let address : Address = patient.addresses[0];
       ret = this.trim(address.street1) + ' ' + 
       this.trim(address.street2) + ' ' + 
       this.trim(address.city) + ' ' + 
       this.trim(address.state) + ' ' + 
       this.trim(address.postalCode) + ' ' + 
       this.trim(address.country);

    }
    return ret;
  }

  getPhone() : string {
    let ret : string = 'Unknown';
    let patient : PatientEntity = this.resolvePrimary();
   
    if (patient && patient.phones && patient.phones.length > 0) {
       let phone : Phone = patient.phones[0];
       if (phone.number) {
        const raw : string = this.trim(phone.number).replace(/\D/g, '');
        ret = '(' + this.trim(phone.area) + ') ' + raw.substring(0, 3) + '-' + raw.substring(3);
       }


    }
    return ret;
  }

  getEvaluationDates() : Date[] {
    let ret : Date[] = [];
    //console.log('getEvaluationDates', this.family.evaluationDates);
    if (this.family.evaluationDates) {
      ret = this.family.evaluationDates
      .map(n =>  (''+n).length < 13 ? //n / 946080000000 < 30 ?
        new Date(n * 1000) :
        new Date(n)
       );
    }
    return ret;
  }

  clearState() {
    console.log('CLEARING STATE');
    this.store.dispatch(new ClearSubscriptions());
    this.family = null;
    this.tabIndex = 1

  }


  isLoading() {
    return !this.family || this.family === null;
  }

  trim(s : string) : string {
    return (!s || s == null || s === 'null') ? '' : s.trim();
  }

  getLastAuthDate(unixTime : number) {
    if (!unixTime)
      return '';
    return new Date(unixTime).toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"});
  }

  sanitizeIdentifier(id: string | undefined): string {
    return Util.sanitizeIdentifier(this.family?.identifier, id);
  }

}
